module.exports = __webpack_public_path__ + "img/homelight.jpg.cc542c7a.webp";